import { render, staticRenderFns } from "./Ekwateur.vue?vue&type=template&id=bd8281f8&scoped=true&"
import script from "./Ekwateur.vue?vue&type=script&lang=js&"
export * from "./Ekwateur.vue?vue&type=script&lang=js&"
import style0 from "./Ekwateur.vue?vue&type=style&index=0&id=bd8281f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8281f8",
  null
  
)

export default component.exports